import { createHandlerChainRunner, Handler } from "@insite/client-framework/HandlerCreator";

type HandlerType = Handler<{
    isOpen: boolean;
}>;

export const LoadInitialValues: HandlerType = ({ dispatch, parameter: { isOpen } }) => {
    if (isOpen) {
     //   dispatch(setInitialValues({}));
    }
};

export const DispatchSetIsOpen: HandlerType = ({ dispatch, parameter: { isOpen } }) => {
    dispatch({
        type: "Components/DesktopDrawer/SetIsOpen",
        isOpen,
    } as any);
};

export const chain = [LoadInitialValues, DispatchSetIsOpen];

const setDesktopDrawerIsOpen = createHandlerChainRunner(chain, "SetDesktopDrawerIsOpen");
export default setDesktopDrawerIsOpen;
